import styled from 'styled-components';
import { spacing } from '@chegg-ui/theme';
export var LoadingIconContainer = styled.div.withConfig({
  componentId: "sc-18hs4bq-0"
})(["display:flex;justify-content:center;align-items:center;"]);
export var PxCaptchaContainer = styled.div.withConfig({
  componentId: "sc-18hs4bq-1"
})(["display:grid;justify-items:center;margin-top:", ";> iframe{margin:0 auto;}#px-captcha:has(*) + ", "{display:none;}"], spacing.px16, LoadingIconContainer);